/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useState } from 'react';
import { MyContext } from '../../Context/MyProvider';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { showToast } from '../../showTost';
import Referlottie from "../../Lottie/refernearn.json";
import Lottie from 'lottie-react';
import Icon from "../../Image/lovef.png";
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
const Refer = () => {
    const { t } = useTranslation();
    const { BaseUrl } = useContext(MyContext);

    const [referdata, setReferData] = useState();
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();
    const currency = secureLocalStorage.getItem("currency");

    useEffect(() => {
        const uid = secureLocalStorage.getItem("Userid");
        if (uid) {
            axios.post(`${BaseUrl}user_api/getdata`, { uid })
                .then((res) => {
                    setReferData(res.data);
                    setLoading(false);
                })
                .catch((error) => {
                    console.error("e_getdata", error);
                });
        } else {
            navigate("/");
        }
    }, []);


    const handleCopyClick = (textToCopy) => {
        navigator.clipboard.writeText(textToCopy).then(() => {
            showToast({ title: t("Text copied to clipboard !!"), id: "success" });
        }).catch((err) => {
            console.error('Failed to copy text: ', err);
        });
    };

    return (
        <div className="">
            {loading
                ? <div className="w-full h-[calc(100vh-90px)] bg-white z-[777] fixed flex items-center justify-center">
                    <div className="loader"></div>
                </div>
                : <div className='h-[100vh] -mt-[150px] flex'>
                    <div className="w-[100%] flex items-center justify-center mt-[50px]">
                        <div className="profile-box">
                            <Lottie
                                className="w-[250px] mx-auto mb-[20px] max-_430_:w-[200px]"
                                animationData={Referlottie}
                                loop={true}
                            />
                            <h1 className='text-center text-[20px] font-[500]'>{t("Earn")} {currency ? currency : "$"}{referdata.signupcredit} {t("For Each Friend You Refer")}</h1>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("Share the Referral Link with Your Friends")}</h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("Friend Gets")} <span className=''>{currency ? currency : "$"}{referdata.signupcredit}</span> {t("On First Complete Transaction")} </h1>
                            </div>
                            <div className="flex items-center gap-[10px] mt-[15px]">
                                <img src={Icon} alt="Icon" className='w-[30px]' />
                                <h1 className='text-[18px]'>{t("You Get")} <span className=''>{currency ? currency : "$"}{referdata.refercredit}</span> {t("On Your Wallet")}</h1>
                            </div>
                            <button onClick={() => handleCopyClick(referdata.code)} className="w-[60%] max-_430_:w-[100%] font-[500] mx-auto bg-[--bgcolor] py-[8px] rounded-[10px] flex items-center justify-center gap-[40px] mt-[20px]">
                                <div className='text-white text-[18px]'>{referdata.code}</div>
                                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.375 21.75H9.625C7.448 21.75 6.25 20.552 6.25 18.375V9.625C6.25 7.448 7.448 6.25 9.625 6.25H18.375C20.552 6.25 21.75 7.448 21.75 9.625V18.375C21.75 20.552 20.552 21.75 18.375 21.75ZM9.625 7.75C8.293 7.75 7.75 8.293 7.75 9.625V18.375C7.75 19.707 8.293 20.25 9.625 20.25H18.375C19.707 20.25 20.25 19.707 20.25 18.375V9.625C20.25 8.293 19.707 7.75 18.375 7.75H9.625ZM3.75 15V5.625C3.75 4.293 4.293 3.75 5.625 3.75H15C15.414 3.75 15.75 3.414 15.75 3C15.75 2.586 15.414 2.25 15 2.25H5.625C3.448 2.25 2.25 3.448 2.25 5.625V15C2.25 15.414 2.586 15.75 3 15.75C3.414 15.75 3.75 15.414 3.75 15Z" fill="white" />
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>}
        </div>
    )
}

export default Refer
/* jshint ignore:end */